module.exports = __webpack_public_path__ + "7e4b29ba/img/verified-icon.f93bbc14.svg";